/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Count_Sessions_OtherInputs */

const en_ui_count_sessions_other = /** @type {(inputs: Ui_Count_Sessions_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sessions`)
};

const de_ui_count_sessions_other = /** @type {(inputs: Ui_Count_Sessions_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Einheiten`)
};

/**
* | output |
* | --- |
* | "{count} sessions" |
*
* @param {Ui_Count_Sessions_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_count_sessions_other = /** @type {((inputs: Ui_Count_Sessions_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Count_Sessions_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_count_sessions_other(inputs)
	return de_ui_count_sessions_other(inputs)
});